var map = {
	"./": 489,
	"./OldUi": 2713,
	"./OldUi.js": 2713,
	"./SpireonNew": 2714,
	"./SpireonNew.js": 2714,
	"./SpireonOld": 2715,
	"./SpireonOld.js": 2715,
	"./index": 489,
	"./index.js": 489,
	"./style": 378,
	"./style.js": 378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4224;